export default __webpack_public_path__ + "static/tik-tok-698dae737da4f5768de48a47c889ec4f.svg";